import { render, staticRenderFns } from "./CartCourse.vue?vue&type=template&id=3f510da7&scoped=true&"
import script from "./CartCourse.vue?vue&type=script&lang=js&"
export * from "./CartCourse.vue?vue&type=script&lang=js&"
import style0 from "./CartCourse.vue?vue&type=style&index=0&id=3f510da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f510da7",
  null
  
)

export default component.exports